import { cn } from '@/lib/utils';

/** New campaigns start in Eastern time until someone changes it in settings. */
export const DEFAULT_TIME_ZONE_ID = 'America/New_York';

export const SIGNUP_PASSWORD_HINT =
  'Must be at least 6 characters and include an uppercase letter, a lowercase letter, and a number.';

// Mirrors the server Identity policy (Program.cs), so a weak password never reaches a 400.
export const isSignupPasswordValid = (password: string) =>
  password.length >= 6 && /[a-z]/.test(password) && /[A-Z]/.test(password) && /[0-9]/.test(password);

/**
 * The explicit pre-auth consent every sign-up shows. The server also records acceptance
 * (RegistrationAcceptanceRecorder); this box is the visible "I clicked I Agree" record per
 * legal-team direction (design §3.2).
 */
export function LegalAgreement({
  checked,
  onChange,
  className,
}: {
  checked: boolean;
  onChange: (checked: boolean) => void;
  className?: string;
}) {
  return (
    <label className={cn('flex items-start gap-2 text-sm text-muted-foreground cursor-pointer', className)}>
      <input type="checkbox" checked={checked} onChange={(e) => onChange(e.target.checked)} className="mt-1" />
      <span>
        I agree to the{' '}
        <a href="/eula" target="_blank" rel="noopener noreferrer" className="underline text-foreground">EULA</a>,{' '}
        <a href="/privacy-policy" target="_blank" rel="noopener noreferrer" className="underline text-foreground">Privacy Policy</a>,{' '}
        and <a href="/terms" target="_blank" rel="noopener noreferrer" className="underline text-foreground">Terms of Service</a>,
        and confirm I am 18 years of age or older.
      </span>
    </label>
  );
}
